







import { Component, Vue, Prop } from 'vue-property-decorator'
import { State, Getter, Action, Mutation } from '../store-helper'
import ExamRevision from '../../api/v2/models/exam_revision'
import { format } from 'date-fns'
import { uniq } from 'lodash'
import { qEditorState } from '../stores'

@Component({
  components: {}
})
export default class RevisionItemComponent extends Vue {
  @Prop({ required: true })
  examRevision: ExamRevision

  get currentExamRevision() {
    return qEditorState.currentExamRevision
  }

  get isActive() {
    return this.currentExamRevision && this.currentExamRevision.id === this.examRevision.id
  }

  chooseExamRevision() {
    qEditorState.setCurrentExamRevision({ examRevision: this.examRevision })
  }

  dateFormat(date: Date) {
    return format(date, 'MM/DD/YYYY HH:mm')
  }
}
